"use strict";

module.exports = function preventDefault(event) {
    event.preventDefault();
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datagrid/lib/utils/preventDefault.js
 ** module id = 929
 ** module chunks = 0
 **/